export default __webpack_public_path__ + "static/media/P102 zu P104.6f6f3888.mp3";